











import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";

/* ===== Gallery Data (Title + Image Mapping) ===== */
const galleryData = [
  { id: 1, imgSrc: "/images/fleets/111.jpg", title: "Maruti Swift Dzire" },
  { id: 2, imgSrc: "/images/fleets/6.jpg", title: "Toyota Etios" },
  { id: 3, imgSrc: "/images/fleets/7.jpg", title: "Honda Amaze" },
  { id: 4, imgSrc: "/images/fleets/8.jpg", title: "Toyota Corolla Altis" },
  { id: 5, imgSrc: "/images/fleets/2.jpg", title: "Maruti Ertiga" },
  { id: 6, imgSrc: "/images/fleets/5.jpg", title: "Tavera" },
  { id: 7, imgSrc: "/images/fleets/9.jpg", title: "Toyota Innova" },
  { id: 8, imgSrc: "/images/fleets/10.jpg", title: "Innova Crysta" },
  { id: 9, imgSrc: "/images/fleets/3.jpg", title: "Scorpio" },
  { id: 10, imgSrc: "/images/fleets/12.jpg", title: "Mini Bus Traveller" },
];

/* ===== Booking Component ===== */
export default function Booking({
   cards = [
  {
    title: "Maruti Swift Dzire",
    company: "Sanavi Travels",
    priceLabel: "Starting ₹999",
    seater: "5 Seater",
    desc:
      "The Maruti Swift Dzire is a reliable and fuel-efficient sedan, perfect for city travel and short outstation trips. It offers comfortable seating and smooth driving experience.",
    image: "/images/fleets/1.jpg",
  },
  {
    title: "Toyota Etios",
    company: "Sanavi Travels",
    priceLabel: "Starting ₹1,099",
    seater: "5 Seater",
    desc:
      "Toyota Etios is known for its durability and comfortable ride quality. Ideal for business trips and family travel with ample legroom and smooth performance.",
    image: "/images/fleets/6.jpg",
  },
  {
    title: "Honda Amaze",
    company: "Sanavi Travels",
    priceLabel: "Starting ₹1,199",
    seater: "5 Seater",
    desc:
      "Honda Amaze delivers premium comfort with stylish interiors and advanced safety features, making it a great option for daily rides and corporate travel.",
    image: "/images/fleets/7.jpg",
  },
  {
    title: "Toyota Corolla Altis",
    company: "Sanavi Travels",
    priceLabel: "Starting ₹1,499",
    seater: "5 Seater",
    desc:
      "Toyota Corolla Altis offers executive-class comfort and refined performance, ideal for premium city rides and long-distance journeys.",
    image: "/images/fleets/8.jpg",
  },
  {
    title: "Maruti Ertiga",
    company: "Sanavi Travels",
    priceLabel: "Starting ₹1,699",
    seater: "7 Seater",
    desc:
      "Maruti Ertiga provides spacious seating for families and small groups. It combines comfort, mileage, and practicality for both local and outstation trips.",
    image: "/images/fleets/2.jpg",
  },
  {
    title: "Tavera",
    company: "Sanavi Travels",
    priceLabel: "Starting ₹1,799",
    seater: "7 Seater",
    desc:
      "Tavera is a dependable multi-utility vehicle designed for comfortable group travel with generous seating space and smooth highway performance.",
    image: "/images/fleets/5.jpg",
  },
  {
    title: "Toyota Innova",
    company: "Sanavi Travels",
    priceLabel: "Starting ₹2,199",
    seater: "7-8 Seater",
    desc:
      "Toyota Innova is one of the most preferred vehicles for family and corporate travel, offering superior comfort, space, and reliability.",
    image: "/images/fleets/9.jpg",
  },
  {
    title: "Innova Crysta",
    company: "Sanavi Travels",
    priceLabel: "Starting ₹2,499",
    seater: "7-8 Seater",
    desc:
      "Innova Crysta delivers luxury-level comfort with premium interiors and powerful performance, perfect for long-distance and VIP travel.",
    image: "/images/fleets/10.jpg",
  },
  {
    title: "Scorpio",
    company: "Sanavi Travels",
    priceLabel: "Starting ₹2,799",
    seater: "7-9 Seater",
    desc:
      "Scorpio is a powerful SUV offering strong road presence and comfortable seating for larger families and adventure trips.",
    image: "/images/fleets/3.jpg",
  },
  {
    title: "Mini Bus Traveller",
    company: "Sanavi Travels",
    priceLabel: "Starting ₹3,999",
    seater: "25-30 Seater",
    desc:
      "Mini Bus Traveller is ideal for large group tours, corporate outings, and family functions with spacious seating and smooth travel experience.",
    image: "/images/fleets/12.jpg",
  },
],
}) {
  const getGalleryItem = (title) =>
    galleryData.find(
      (item) => item.title.toLowerCase() === title.toLowerCase()
    );

  const handleWhatsAppBooking = (title) => {
    const phone = "917387507373";
    const message = `Hello Sanavi Travels, I want to book ${title}. Please share more details.`;
    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <>


 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title">Booking</h2>
        </div>
      </div>
    </section>



   

      {/* ===== Booking Cards ===== */}
      <section
        className="taxi-rates-page section-space"
        style={{ backgroundColor: "#f9fafc", padding: "80px 0" }}
      >
        <div className="container">
          <div className="row g-4 justify-content-center">
            {cards.map((c, idx) => {
              const galleryItem = getGalleryItem(c.title);

              return (
                <div className="col-xl-4 col-md-6 d-flex" key={idx}>
                  <div className="taxi-card d-flex flex-column w-100">
                    {/* Image */}
                    <div style={{ background: "#F26722", padding: 20 }}>
                      <img
                        src={galleryItem?.imgSrc || c.image}
                        alt={c.title}
                        style={{
                          width: "100%",
                          maxHeight: 220,
                          objectFit: "contain",
                        }}
                      />
                    </div>

                    {/* Content */}
                    <div
                      style={{
                        background: "#000",
                        color: "#fff",
                        padding: 25,
                        flex: 1,
                      }}
                      className="d-flex flex-column justify-content-between"
                    >
                      <div>
                        <h3 className="text-center">{c.title}</h3>
                        {/* <p className="text-center text-muted">{c.company}</p> */}
                        {/* <p className="text-center">{c.desc}</p> */}
                        <p className="text-center fw-bold">Seater: {c.seater}</p>
                        {/* <p className="text-center text-success fw-bold">{c.priceLabel}</p> */}
                      </div>

                      <button
                        onClick={() => handleWhatsAppBooking(c.title)}
                        className="btn btn-success mt-3"
                      >
                        <i className="fab fa-whatsapp" /> Book Now
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
